import { useContext } from 'react'

import { BackOfficePrivilegeName } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import AuthContext, { UserProfile } from '@contexts/Auth/AuthContext'

export { BackOfficePrivilegeName as PrivilegeName }

export interface UseUserPermissionProps {
  privilegeName: BackOfficePrivilegeName | BackOfficePrivilegeName[]
  quantifier?: 'some' | 'every'
}

export const useUserPermission = ({
  privilegeName,
  quantifier,
}: UseUserPermissionProps): boolean => {
  const auth = useContext(AuthContext)
  const user = auth.user as UserProfile
  const { permissions } = user

  if (!permissions) return false

  const hasPrivilege = (privilege: BackOfficePrivilegeName) => permissions.includes(privilege)

  return Array.isArray(privilegeName)
    ? quantifier === 'some'
      ? privilegeName.some(hasPrivilege)
      : privilegeName.every(hasPrivilege)
    : permissions.includes(privilegeName)
}
